import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PAGES from "@/seo/pages.json";
import { TOOL_LIST } from "@/lib/tools";
import { useLang } from "@/i18n";
import { Breadcrumb } from "@/components/Breadcrumb";

export default function ToolsHub() {
  const { lang, t } = useLang();
  const m = PAGES.tools[lang];
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6" data-testid="tools-hub">
      <Breadcrumb pageKey="tools" />
      <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{m.h1}</h1>
      <p className="mt-4 max-w-2xl text-slate-600">{m.intro}</p>
      <div className="mt-14 space-y-14">
        {TOOL_LIST.map((tl) => {
          const main = Object.entries(PAGES).find(([, p]) => p.tool === tl.slug && p.main);
          const variants = Object.entries(PAGES).filter(([, p]) => p.tool === tl.slug && !p.main && !p.type);
          const Icon = tl.icon;
          return (
            <section key={tl.slug} data-testid={`hub-section-${tl.slug}`}>
              <div className="flex items-start gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl text-white" style={{ background: tl.color }}><Icon className="h-5 w-5" /></span>
                <div className="min-w-0">
                  <h2 className="text-xl font-semibold text-slate-900 sm:text-2xl"><Link to={main[1].paths[lang]} className="hover:underline" data-testid={`hub-main-${tl.slug}`}>{main[1][lang].h1}</Link></h2>
                  <p className="mt-1 text-sm text-slate-600">{main[1][lang].description}</p>
                </div>
              </div>
              <ul className="mt-5 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {variants.map(([k, p]) => (
                  <li key={k}>
                    <Link to={p.paths[lang]} data-testid={`hub-link-${k}`} className="group flex h-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 transition-colors hover:border-slate-900">
                      <span className="flex-1">{p[lang].h1}</span>
                      <ArrowRight className="h-4 w-4 shrink-0 text-slate-400 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
      <p className="mt-16 text-sm text-slate-500">{t("hub.guidesHint")} <Link to={PAGES.guides.paths[lang]} className="font-semibold text-slate-900 hover:underline">{PAGES.guides[lang].h1} →</Link></p>
    </div>
  );
}
